import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { UserSummaryReferenceData } from "@idw-types/state/user-summary-state";

export const getMonthlyUsersReferenceDataRequest = async (): Promise<{ data: UserSummaryReferenceData, error: any }> => {
    const route = apiRoutes.reports.monthlyUsers.referenceData;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};